import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=e5d9cdf2&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5d9cdf2')) {
      api.createRecord('e5d9cdf2', component.options)
    } else {
      api.reload('e5d9cdf2', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=e5d9cdf2&", function () {
      api.rerender('e5d9cdf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IAVyz2XvJ3DO/JS/comp/ImgFallback.vue"
export default component.exports